// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1fQdd","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3-9BW","obliqueLine":"membershipbadge_obliqueLine__1Bg_Z"};